// OTP verification. The backend's SendOtpOnWhatsAppbyMobileNumber returns the
// generated OTP (same as the Flutter flow), which we compare locally, then look
// up the user record to establish the session.

import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Button, TextField, Typography, Alert, CircularProgress } from '@mui/material';
import { useApp } from '../state/AppContext';
import { login } from '../api/api';

export default function OtpScreen() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { setSession } = useApp();
  const mobile = state?.mobile || '';
  const expectedOtp = state?.otp != null ? String(state.otp) : '';

  const [otp, setOtp] = useState('');
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const verify = async () => {
    setError('');
    if (expectedOtp && otp.trim() !== expectedOtp) {
      setError('Incorrect OTP.');
      return;
    }
    setLoading(true);
    try {
      // OTP confirmed; complete login with the PIN to fetch the user record.
      const res = await login(mobile, pin.trim());
      const arr = res.data;
      if (Array.isArray(arr) && arr.length && arr[0].UserId) {
        // Persist the entered credentials so a later session refresh has them.
        const merged = [{ ...arr[0], MobileNumber: String(mobile).trim(), Password: pin.trim() }, ...arr.slice(1)];
        setSession(merged);
        navigate('/home', { replace: true });
      } else {
        setError('Could not load your account. Check your PIN.');
      }
    } catch (e) {
      setError('Verification failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      justifyContent: 'center', alignItems: 'center', p: 3, gap: 2,
      bgcolor: 'background.default',
    }}>
      <Typography variant="h5" color="text.primary" fontWeight={700}>Verify OTP</Typography>
      <Typography variant="body2" color="text.secondary">
        Sent on WhatsApp to {mobile}
      </Typography>
      {error && <Alert severity="error" sx={{ width: '100%', maxWidth: 360 }}>{error}</Alert>}
      <TextField label="OTP" value={otp}
        onChange={(e) => setOtp(e.target.value.replace(/\D/g, ''))}
        inputProps={{ inputMode: 'numeric' }}
        sx={{ width: '100%', maxWidth: 360 }} />
      <TextField label="PIN" type="password" value={pin}
        onChange={(e) => setPin(e.target.value.replace(/\D/g, ''))}
        inputProps={{ inputMode: 'numeric', maxLength: 4 }}
        sx={{ width: '100%', maxWidth: 360 }} />
      <Button variant="contained" onClick={verify} disabled={loading}
        sx={{ width: '100%', maxWidth: 360, py: 1.3 }}>
        {loading ? <CircularProgress size={22} /> : 'VERIFY & CONTINUE'}
      </Button>
    </Box>
  );
}
